import React from 'react';
import PropTypes from 'prop-types';

const InputCheck = (props) => {
  return (
    <div className={props.wrapclassName ? props.wrapclassName +" form-group inputCheck" : ' form-group inputCheck' }>
      <input
        id={props.id}
        name={props.name}
        value={props.value}
        type={props.type}
        onChange={props.onChange}
        disabled={props.disabled} 
        checked={props.checked}
      /> <label className="inputLebel" htmlFor={props.id}>{props.label}{props.children}</label>
    </div>
  )
}

InputCheck.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  // Console-warning fix: `value` has no bearing on a checkbox's checked state (that's the separate
  // `checked` prop below) — several long-standing callers in this exact form (Ex_Serviceman,
  // is_DateConfirm, is_ConsentAccepted) never pass it at all, so requiring it was never actually enforced
  // in practice, only logged as a false-positive warning on every one of those checkboxes.
  value: PropTypes.any,
  type: PropTypes.string.isRequired,
  // `label` is rendered as-is (see render() above) and every real caller passes a bilingual JSX element,
  // not a plain string — same reasoning as DropdownList's `heading` fix.
  label: PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,  
  checked: PropTypes.bool,
  wrapclassName: PropTypes.string,
};

export default InputCheck;